import React from 'react';
import { useAppContext } from '../../context/AppContext';

interface TermsCheckProps {
  onTermCheck: (checked: boolean) => void;
  termsText: string;
}

const TermsCheck = ({ onTermCheck, termsText }: TermsCheckProps) => {
  const { state } = useAppContext();
  const [isChecked, setIsChecked] = React.useState<boolean>(false);

  const handleCheckboxChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onTermCheck(newValue);
  };

  return (
    <div className="w-full flex flex-row items-center justify-start mt-5">
      <input
        type="checkbox"
        id="terms"
        className="mr-3 w-4 h-4"
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
      <label htmlFor="terms" className="text-sm cms-html">
        {termsText}
      </label>
    </div>
  );
};

export default TermsCheck;